module.exports = __webpack_public_path__ + "2ce817cc743f7ffeffadfd9d8b2e8ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-oisoginotokorosumimasenn.png
// module id = 2054
// module chunks = 4